export enum PaymentState {
    Canceled = 'Canceled',
    Charged = 'Charged',
    Failed = 'Failed',
    Pending = 'Pending',
    Verifying = 'Verifying',
}
